const FOOTER_HEIGHT_DESKTOP_COCHES = 770
const FOOTER_HEIGHT_DESKTOP_MOTOS = 630
const FOOTER_HEIGHT_MOBILE_COCHES = 1929
const FOOTER_HEIGHT_MOBILE_MOTOS = 1580

export const FOOTER_HEIGHTS = {
  COCHES: {
    desktop: FOOTER_HEIGHT_DESKTOP_COCHES,
    mobile: FOOTER_HEIGHT_MOBILE_COCHES,
    tablet: FOOTER_HEIGHT_MOBILE_COCHES
  },
  MOTOS: {
    desktop: FOOTER_HEIGHT_DESKTOP_MOTOS,
    mobile: FOOTER_HEIGHT_MOBILE_MOTOS,
    tablet: FOOTER_HEIGHT_MOBILE_MOTOS
  }
}

export const BACKGROUND_COLORS = {
  INHERIT: 'inherit',
  WHITE: 'white'
}
